/*eslint-disable*/
import Api from "../";

class PresentationsApi {
    static list(params, cancelToken = null) {
        return Api.axios.post('/presentations/list', params, {cancelToken}).then(response => response.data);
    }

    static create (params) {
        return Api.axios.post('/presentations/create', params)
            .then(response => response.data);
    }

    static show (id) {
        return Api.axios.get('/presentations/' + id)
            .then(response => response.data);
    }

    static update (params) {
        return Api.axios.post('/presentations/' + params.id, params.formData)
            .then(response => response.data)
    }

    static delete (id) {
        return Api.axios.delete('/presentations/' + id)
            .then(response => response.data)
    }
}

export default PresentationsApi;
